(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page"]) return;
  try {
    
// Ajoutez du JS personnalisé ici si nécessaire

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-policy"]) return;
  try {
    
// Ajoutez du JS personnalisé ici si nécessaire

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommendation-pdp"] && !Shopify.designMode) return;
  try {
    
  const products = [];
  const productRecommendationsSection = document.querySelector('.product-recommendations');

  document.addEventListener('DOMContentLoaded', () => {
    if (!productRecommendationsSection) return;

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        let count = html.querySelector('.recommendation-section').dataset.count;
        if (recommendations && count) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        } else {
          productRecommendationsSection.innerHTML = '';
        }

        setTimeout(() => {
          recommendationSlider();
        }, 200);
      })
      .catch((e) => {
        console.error(e);
      });
  });

  } catch(e) { console.error(e); }
})();
})();
